// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"d98a680e","453":"7439fe58","635":"b0d9c6ed","696":"cee6a166","709":"592045d4","899":"04548c05"}[chunkId] + ".chunk.js";
};